
import { request } from "@/utils/api/legacyRequest";
import { toastI18n } from "@/components/common/Toast";
import { API_PUT } from "./middlewareConstants";
import { BEGIN_REQUEST, FINISH_REQUEST } from "../metadata/metadataActions";

const apiPutMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (action.type !== API_PUT) {
      return next(action);
    }
    const {
      payload: { url, success, body, onSuccess, token, onError },
    } = action;

    dispatch({ type: BEGIN_REQUEST });

    request(url, token, "PUT", body)
      .then(
        (res) => {
          // `request` resolves only for 2xx — it rejects the Response itself
          // on anything else — so there is no failure branch to check for
          // here. This handler only runs on that success path, so anything it
          // throws (e.g. from `success`/`onSuccess`) must not fall into the
          // rejection handler below and be mistaken for the request failing.
          // The try/catch (rather than letting it reject the chain) keeps
          // that throw from becoming an unhandled rejection that still has to
          // reach `finally` below to unstick `isRequesting`.
          try {
            if (success !== null) {
              dispatch(success(res.data || res));
            }
            if (onSuccess !== null) {
              onSuccess(res.data || res);
            }
          } catch (err) {
            console.error(err);
          }
        },
        (err) => {
          console.error(err);
          // The rejection is the Response for an HTTP failure and an Error
          // for a network-level one, hence the guard rather than a bare
          // `err.status`.
          const status = typeof err?.status === "number" ? err.status : null;
          try {
            if (onError) {
              onError({ error: status });
            } else {
              dispatch(toastI18n("error", "SomethingWentWrong"));
            }
          } catch (handlerErr) {
            // A caller-supplied onError throwing must not skip `finally`
            // below — that would leave `metadata.isRequesting` stuck at
            // `true`, disabling every settings page's Save and Cancel.
            console.error(handlerErr);
          }
        }
      )
      .finally(() => dispatch({ type: FINISH_REQUEST }));

    return false;
  };

export default apiPutMiddleware;
